import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { Pedido } from '../models/pedido';
import { PedidoService } from '../pedido.service';


@Injectable({ providedIn: 'root'})
export class PedidoDetalheResolver implements Resolve<Observable<Pedido>>{

    constructor(private pedidoService: PedidoService) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot):any {
        const idPedido = route.params.id;
        return this.pedidoService.getPedido(idPedido).pipe(
            map((pedido) => ({ pedido: pedido })),
            catchError((error) => {
              const message = `Retrieval error: ${error}`;
              console.error(message);
              return of({ pedido: null, error: message });
            }),
          );
    }

}